var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.src),expression:"!src"}],staticClass:"imgOut"},[_c('img',{staticClass:"img",staticStyle:{"width":"100%"},attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }